<div id="outer" class="well container">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="well-title">
        <div class="col-md-12">EQUIP Connector Key</div>
    </div>
    <div class="col-md-12 well-content">
        <div class="panel panel-default">
            <div class="panel-heading">Configured Keys</div>
            <div class="panel-body">
                <form nz-form class="form-horizontal">
                    <div class="form-group">
                        <label for="uniqueKey" class="col-md-2 control-label">Install Unique Key</label>
                        <div class="col-md-6">
                            <input
                                id="uniqueKey"
                                type="text"
                                class="form-control"
                                [(ngModel)]="uniqueKeyInput"
                                name="uniqueKey" />
                        </div>
                        <div class="col-md-4">
                            <button nz-button nzType="primary" (click)="setUniqueKey()">Save Unique Key</button>
                            <button
                                nz-button
                                nzDanger
                                style="margin-left: 8px"
                                nz-popconfirm
                                nzPopconfirmTitle="Clear the connector's unique key binding?"
                                (nzOnConfirm)="clearUniqueKey()">
                                Clear
                            </button>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">License Key</label>
                        <div class="col-md-6">
                            <input type="text" class="form-control" [value]="model.CurrentLicenseKey || ''" readonly />
                        </div>
                        <div class="col-md-4">
                            <button
                                nz-button
                                nzType="primary"
                                nz-popconfirm
                                nzPopconfirmTitle="Regenerate the license key? The on-site connector must be reconfigured with the new key."
                                (nzOnConfirm)="regenerateLicense()">
                                Regenerate License
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div class="panel panel-default">
            <div class="panel-heading">Last Reported by Connector</div>
            <div class="panel-body">
                <form nz-form class="form-horizontal">
                    <div class="form-group">
                        <label class="col-md-2 control-label">Server Name</label>
                        <div class="col-md-6">
                            <input type="text" class="form-control" [value]="model.LastServerName || ''" readonly />
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Install Path</label>
                        <div class="col-md-6">
                            <input type="text" class="form-control" [value]="model.LastInstallPath || ''" readonly />
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Archive Path</label>
                        <div class="col-md-6">
                            <input type="text" class="form-control" [value]="model.LastArchivePath || ''" readonly />
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Unique Key</label>
                        <div class="col-md-6">
                            <input type="text" class="form-control" [value]="model.LastUniqueKey || ''" readonly />
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">License Key</label>
                        <div class="col-md-6">
                            <input type="text" class="form-control" [value]="model.LastLicenseKey || ''" readonly />
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Connector Version</label>
                        <div class="col-md-6">
                            <input type="text" class="form-control" [value]="model.LastVersion || ''" readonly />
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Last Report Date (UTC)</label>
                        <div class="col-md-6">
                            <input type="text" class="form-control" [value]="model.LastReportDate || ''" readonly />
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
